module.exports = __webpack_public_path__ + "static/media/ellipses-icon.e6047898.svg";